export default __webpack_public_path__ + "static/media/rails-negative.a2418fc5.svg";